import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fb7b555"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "unidentified-card flex overflow-hidden rounded-lg border border-solid border-neutralLight text-left",
  "data-testid": "unidentified-coverage-card"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "unidentified-card__bar" }, null, -1))
const _hoisted_3 = { class: "unidentified-card__body flex flex-1 flex-col gap-1.5 px-3 py-2.5" }
const _hoisted_4 = { class: "flex items-center gap-2" }
const _hoisted_5 = {
  class: "unidentified-card__avatar",
  "aria-hidden": "true"
}
const _hoisted_6 = {
  viewBox: "0 0 24 24",
  class: "w-3.5 h-3.5"
}
const _hoisted_7 = ["d"]
const _hoisted_8 = { class: "text-sm text-[#34344F]" }
const _hoisted_9 = {
  key: 0,
  class: "ml-auto rounded px-2 py-0.5 text-xs bg-white border border-solid border-neutralLight"
}
const _hoisted_10 = {
  class: "text-sm text-textPrimary",
  "data-testid": "unidentified-coverage-card-responsible"
}
const _hoisted_11 = {
  key: 0,
  class: "text-xs text-[#68688D]",
  "data-testid": "unidentified-coverage-card-note"
}
const _hoisted_12 = {
  key: 1,
  class: "flex flex-wrap gap-2 pt-1"
}

import { mdiAccountOutline } from '@mdi/js'
import { UNIDENTIFIED_COVERAGE_LABEL } from '@/utils/coverage'


export default /*#__PURE__*/_defineComponent({
  __name: 'UnidentifiedCoverageCard',
  props: {
    responsibleName: { default: null },
    note: { default: null },
    stationTypeLabel: { default: null },
    compact: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, [
          (_openBlock(), _createElementBlock("svg", _hoisted_6, [
            _createElementVNode("path", {
              d: _unref(mdiAccountOutline),
              fill: "currentColor"
            }, null, 8, _hoisted_7)
          ]))
        ]),
        _createElementVNode("b", _hoisted_8, _toDisplayString(_unref(UNIDENTIFIED_COVERAGE_LABEL)), 1),
        (_ctx.stationTypeLabel && !_ctx.compact)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.stationTypeLabel), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.compact)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode("Responsável: ")
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode("Responsável pela cobertura: ")
            ], 64)),
        _createElementVNode("b", null, _toDisplayString(_ctx.responsibleName || 'não informado'), 1)
      ]),
      (_ctx.note && !_ctx.compact)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Obs.: " + _toDisplayString(_ctx.note), 1))
        : _createCommentVNode("", true),
      (!_ctx.compact && _ctx.$slots.default)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _renderSlot(_ctx.$slots, "default")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})